export class PosFormFieldsModel {
  public id: string = null;
  public lat: number = null;
  public lng: number = null;
  public name: string = null;
  public openingSchedule: string = null;
  public phoneNumber: string = null;
  public postalCode: string = null;
  public shoppingCenter: string = null;
  public city: string = null;
  public street: string = null;
  public streetNumber: string = null;
  public storeCode: string = null;
  public category: string = null;
  public type: string = null;
  public description: string = null;

  private static instance: PosFormFieldsModel;

  constructor() {
    if (PosFormFieldsModel.instance) {
      return PosFormFieldsModel.instance;
    }

    PosFormFieldsModel.instance = this;
  }
}
